import { gql } from "@apollo/client";

const DEDUCTION_TYPE_MUTATION_FIELDS = `
  typeId
  name
  deductionTypeKey
  categoryId
  categoryName
  parentId
  parentName
  helpText
  metadata
  subTypeCount
  isLinked
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const CREATE_MASTER_DATA_DEDUCTION_TYPE = gql`
  mutation CreateMasterDataDeductionType(
    $params: CreateMasterDataDeductionTypeInput!
  ) {
    createMasterDataDeductionType(params: $params) {
      ${DEDUCTION_TYPE_MUTATION_FIELDS}
    }
  }
`;

export const UPDATE_MASTER_DATA_DEDUCTION_TYPE = gql`
  mutation UpdateMasterDataDeductionType(
    $params: UpdateMasterDataDeductionTypeInput!
  ) {
    updateMasterDataDeductionType(params: $params) {
      ${DEDUCTION_TYPE_MUTATION_FIELDS}
    }
  }
`;

export const DELETE_MASTER_DATA_DEDUCTION_TYPES = gql`
  mutation DeleteMasterDataDeductionTypes(
    $params: DeleteMasterDataDeductionTypesInput!
  ) {
    deleteMasterDataDeductionTypes(params: $params) {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;

export const DELETE_ALL_MASTER_DATA_DEDUCTION_TYPES = gql`
  mutation DeleteAllMasterDataDeductionTypes(
    $params: DeleteAllMasterDataDeductionTypesInput
  ) {
    deleteAllMasterDataDeductionTypes(params: $params) {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;
